import { atomWithReset } from 'jotai/utils'

export const highlightedCellAtom = atomWithReset<Record<string, boolean>>({})
